var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemPresentations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 1a1 1 0 0 1 1 1v1h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7v1.132l6.142.877a1 1 0 0 1-.284 1.981L12 21.01l-6.858.98a1 1 0 0 1-.284-1.981L11 19.132V18H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7V2a1 1 0 0 1 1-1m8 4H4v11h16zm-4 2.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2ZM10 11a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Zm6-1.5h-2v2h2zM10 8a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Z"
})));
export default SvgGemPresentations;